import { createContext } from 'react';

export const AppHeaderTitleSlotContext = createContext<HTMLElement | null>(null);
